import React from 'react'

interface Props {
  widgetCode: string
}

export const AttractionWidget = ({ widgetCode }: Props) => (
  <div dangerouslySetInnerHTML={{ __html: widgetCode }} />
)
